module.exports = __webpack_public_path__ + "img/img006.4895bf4e.png";